import * as TYPES from './types';

// Set loading to true for next render
const clearMovie = () => ({type: TYPES.SET_MOVIE_LOADING});

export default clearMovie;
